import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import usePosUserSettingsQuery from "@/shared/queries/pos/usePosUserSettingsQuery";
import { errorToast } from "@/shared/utils/helpers";
import { AppsmenError, PosUserSettings } from "@/shared/utils/interfaces";
import { OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const usePosOrderPost = () => {
  const branch = useBranchId();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation<any, AppsmenError, any>({
    mutationFn: (data: Partial<OrderV2>) => {
      // POS and kiosk orders always carry the terminal chosen for this account.
      const posUserSettings = queryClient.getQueryData<PosUserSettings>([
        "pos-user-settings",
        branch,
      ]);
      return post2(
        `internal/anonymous/websites/v2/orders/information/${branch}`,
        {
          ...data,
          order_information: {
            ...data?.order_information,
            pin_terminal:
              data.order_information.payment_method_id !== 22
                ? undefined
                : (posUserSettings?.default_pos_terminal_id ?? undefined),
          },
        }
      );
    },
    onSuccess: () => {
      toast.success(t("posOrders.orderPlaced"));
    },
    onError: (error) => {
      const showError =
        error.response?.data?.error_id ===
        "paynl.onlinePaymentConnectionFailed";
      showError && errorToast(error.response.data.error_message);
    },
  });

  return mutation;
};

export default usePosOrderPost;
